<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_order') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/sale/order" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('sale_order_no')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.FromDate"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.ToDate"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <CustomerDropdown :is-all="true" :place="$t('all')" @select="customerChange"></CustomerDropdown>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.Status" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="Draft">Draft</option>
                                    <option value="Nothing To Invoice">Nothing To Invoice</option>
                                    <option value="To Invoice">To Invoice</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.StockStatus" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Done">Done</option>
                                    <option value="Over">Over</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor table-scroll">
                        <thead>
                            <tr>
                                <th class="text-center">{{$t('no')}}</th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Num')">{{ $t('code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Date')">{{ $t('date') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('CustomerName')">{{ $t('customer') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Phone')">{{ $t('phone') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('SaleRep')">{{ $t('sale_reputation') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('TotalAmount')">{{ $t('total') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Status')">{{ $t('status') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('StockStatus')">{{ $t('stock_out') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>
                                    <router-link :to="{name: 'sale_order_preview', params: {id: ret.Id}}">{{ret.Num}}</router-link>
                                </td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td>{{ret.Phone}}</td>
                                <td>{{ret.SaleRep}}</td>
                                <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                <td class="cell-badge" v-html="$statusLabel(ret.StockStatus)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CustomerDropdown } from '../Customer';
export default {
    components: { CustomerDropdown },
    data(){
        return{
            query:{
                FromDate: '',
                ToDate: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                StockStatus: '',
                Status: '',
                SortType: '',
                SortField: ''
            },
            list: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.query.IsAdmin = this.permission==1?true:false;
            this.$api().post('sale/orders', this.query).then(res => {
                if(this.$isValid(res)){
                    this.list = res.data.Json.Orders;
                    this.query.Total = res.data.Total;
                }
            }).finally(function() { loading.hide(); });
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        customerChange(e){
            if(e == null) this.query.CustomerId = '';
            else this.query.CustomerId = e.Id;
            this.toList();
        }
    },
    computed: {
        permission(){
            return this.$store.state.userGroup;
        }
    }
}
</script>
